import TypeTabContainer from './container';

function TypeTab() {
  return <TypeTabContainer />;
}

export default TypeTab;
